module.exports = __webpack_public_path__ + "media/images/edogawa_seat_map_202402-9184691b77461a8864576bd9995bbf32.png";